import { useContext, useEffect } from 'react';
import HelpContext from '../../services/Context/HelpContext';

const useHelp = (helpFile) => {
  const helpContext = useContext(HelpContext);
  useEffect(() => {
    helpContext?.setHelpFile(helpFile);
  }, [helpContext, helpFile]);
};
export default useHelp;
